import React, {useCallback, useContext, useEffect, useState} from 'react'
import {useHttp} from '../hooks/http.hook'
import {AuthContext} from '../context/AuthContext'
import {getAuthHeader, getPathBack, objectLang, setErrorWindow, setLocalStorageItem} from "../functions"
import {LoaderClass} from "../elements/LoaderClass"
import config from "../config.json"
import {ModalWin} from "../elements/ModalWin"
import {HelpWindowClass} from "../elements/HelpWindowClass"
import {MainPageNotAuthClass} from "../components/MainPageNotAuthClass"
import {useNavigate} from 'react-router-dom'

export const HelpWindowPage = () => {
    setLocalStorageItem('page', 'HelpWindowPage')
    const ok = true
    const navigate = useNavigate()
    const lang = objectLang().language
    const auth = useContext(AuthContext)
    const {loading, request} = useHttp()
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const [user, setUser] = useState(null)
    const [isAuth, setIsAuth] = useState(false)
    const [show, setShow] = useState(true)

    const getUser = useCallback(async () => {
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            const data = await request(
                `${host}/api/user/check`,
                'GET',
                null,
                {
                    Authorization: getAuthHeader(auth)
                })

            if (!ok) {
                setDataModal(setErrorWindow(
                    '',
                    590,
                    lang.messages[`code_${data.code}`],
                    lang.modal.errors.btnOK, getPathBack())
                )
            }

            if (data.user) {
                setIsAuth(true)
                setUser(data.user)
                if (data['newAccessToken']) auth.accessToken = data['newAccessToken']
            }

        } catch (e) {
            console.error(e.message)
        }
    }, [request, auth, lang, ok])

    useEffect(() => {
        getUser().then()
    }, [getUser])

    const closeHandler = () => {
        setShow(false)
    }

    const sendHandler = async (body) => {
        let host = window.location.host === 'localhost:3000' ? config.localHost : config.onrender

        try {
            const data = await request(
                `${host}/api/user/request-help`,
                'POST',
                body,
                {
                    Authorization: getAuthHeader(auth)
                })

            if (data.status > 200) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code))
            } else {
                if (data['newAccessToken']) auth.accessToken = data['newAccessToken']
                navigate('/', { replace: true })
            }

        } catch (e) {
            navigate('/', { replace: true })
        }
    }

    if (!ok) {
        return (
            <>
                <ModalWin data={dataModal}/>
            </>
        )
    }

    if (loading) {
        return <LoaderClass/>
    }

    if (!allowed) {
        return (
            <>
                <ModalWin data={dataModal}/>
            </>
        )
    }

    if (!isAuth) {
        return (
            <>
                <MainPageNotAuthClass
                    lang={lang}
                    currentLang={lang.lang}
                />
            </>
        )
    }

    if (ok && isAuth) {
        return (
            <>
                <HelpWindowClass
                    lang={lang}
                    show={show}
                    closeHandler={closeHandler}
                    sendHandler={sendHandler}
                    user={user}
                />
            </>
        )
    }
}